import { createSlice } from '@reduxjs/toolkit';

const AppointmentSlice = createSlice({
  name: 'appointment',
  initialState: {
    data: [],
    selectedFromDate:"",
    selectedToDate:"",
    activePaginationPage: 1,
    hasUpdated: false,
    branchAppointmentDetails: null
  },
  reducers: {
    setAppointmentData: (state, action) => {
      state.data = action.payload;
    },
    setHasUpdated: (state, action) => {
      state.hasUpdated = action.payload;
    },
    setDateRange: (state, action) => {
      state.selectedFromDate = action.payload.selectedFromDate;
      state.selectedToDate = action.payload.selectedToDate;
    },
    setActivePaginationPage: (state, action) => {
      state.activePaginationPage = action.payload;
    },
    setBranchAppointmentDetails: (state, action) => {
      state.branchAppointmentDetails = action.payload;
    }
  }
});

export const { setAppointmentData, setDateRange, setActivePaginationPage, setBranchAppointmentDetails } = AppointmentSlice.actions;
export default AppointmentSlice.reducer;